module.exports = __webpack_public_path__ + "static/img/silver.917c21c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ranks/silver.png
// module id = Q6vc
// module chunks = 1